import { DEFAULT_THEME, Theme } from '@/types/theme'
import { create } from 'zustand'

export interface ThemeStore {
  tenantTheme: Theme
  applyTenantTheme: (theme: Theme) => void
}

export const useThemeStore = create<ThemeStore>((set) => ({
  tenantTheme: DEFAULT_THEME,
  applyTenantTheme: (theme: Theme) => {
    set(() => ({
      tenantTheme: theme,
    }))
  },
}))
